import CheckmarkOutlineIcon from '../../../../assets/icons/checkmark-outline.svg?react';
import CheckmarkIcon from '../../../../assets/icons/checkmark.svg?react';
import DragIcon from '../../../../assets/icons/drag-and-drop.svg?react';
import RemoveIcon from '../../../../assets/icons/remove.svg?react';
import { Editor } from '../../../editor/editor.tsx';
import { useDragControls, Reorder } from 'framer-motion';
import { IMultipleAnswer } from '../create-question-form.tsx';
import { useEffect, useState } from 'react';
import Tooltip from '../../../common/tooltip.tsx';
import { orderToLetter } from '../../../../utils/common-utils.ts';

interface IMultipleChoice {
  answer: IMultipleAnswer;
  onRemove: (id: string) => void;
  onClickCorrect: (id: string) => void;
  onChange: (id: string, text: string) => void;
  index: number;
}

const MultipleChoice = ({
  answer,
  onRemove,
  onChange,
  onClickCorrect,
  index,
}: IMultipleChoice) => {
  const [text, setText] = useState(answer.text);
  const controls = useDragControls();

  useEffect(() => {
    onChange(answer.id, text);
  }, [answer.id, onChange, text]);

  return (
    <Reorder.Item
      dragControls={controls}
      dragListener={false}
      value={answer}
      className={'my-2 flex w-full select-none items-center'}
    >
      <div className={'left-[-0.25rem] flex shrink-0 items-center'}>
        <div className={'flex flex-col gap-1'}>
          <Tooltip tip={'Mark if this is the correct answer'}>
            <span
              className={'cursor-pointer hover:scale-150 transition-all'}
              onClick={() => onClickCorrect(answer.id)}
            >
              {answer.correct ? (
                <CheckmarkIcon fill={'#275AD3'} />
              ) : (
                <CheckmarkOutlineIcon stroke={'#6B7280'} />
              )}
            </span>
          </Tooltip>

          <div
            className={'cursor-grab hover:scale-150 transition-all'}
            onPointerDown={(event) => controls.start(event)}
          >
            <DragIcon />
          </div>

          <span
            className={'cursor-pointer rounded hover:scale-150 transition-all'}
            onClick={() => onRemove(answer.id)}
          >
            <RemoveIcon stroke={'#F05252'} />
          </span>
        </div>

        <span className={'mx-2 font-semibold'}>{orderToLetter(index)}.</span>
      </div>
      <div className={'flex flex-1 min-w-0'}>
        <Editor
          onChange={setText}
          defaultMarkdownValue={answer.text}
          className={'min-h-[50px] w-full text-base'}
        />
      </div>
    </Reorder.Item>
  );
};

export default MultipleChoice;
